import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'


const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagNewProducts",
    title: "Auto Tag New Products",
    description: "Automatically add tags to new products. Create New Arrivals tag.",
    example: "Allows you to add 'New Arrivals' tag to products by specifying the amount of days a product is considered new.",
    additional: [
        "Specify the amount of days for new tags",
        "Choose publish date or date of creation as reference point",
    ],
    legacy: false,
    inProgress: false,
    previewType: "Product",
    dataPermissions: ["products"],
    allowPreview: true,
    tags: ["Products", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagNewProducts",
                daysSinceReference: 30,
                referenceDateType: "DateCreated",
                newProductTag: "New Arrivals",
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {
                    if (rule.settings.daysSinceReference == null || rule.settings.daysSinceReference === "") {
                        errors["daysSinceReference"] = "Fields is required";
                    }

                    if (rule.settings.referenceDateType == null || rule.settings.referenceDateType === "") {
                        errors["referenceDateType"] = "Fields is required";
                    }

                    if (rule.settings.newProductTag == null || rule.settings.newProductTag === "") {
                        errors["newProductTag"] = "Fields is required";
                    }
                },
            ], null);
    }
};

export default ruleDefinition;